import type { PaymentTxnStatus } from '../../../types'
import { paymentTxnStatusLabels } from '../../../data/payments'
import { cn } from '../../../utils/cn'

/** Widths and fills are fixed per label in the design rather than derived from padding. */
const STYLES: Record<PaymentTxnStatus, string> = {
  paid: 'w-[47px] bg-dash-pill-paid text-dash-pill-ink',
  pending: 'w-[64px] bg-[rgba(255,112,39,0.35)] text-[#ED6A27]',
  failed: 'w-[55px] bg-[#F8C9C9] text-[#C41F1F]',
  refunded: 'w-[72px] bg-[#E8E8E8] text-[#575757]',
}

type PaymentStatusBadgeProps = {
  status: PaymentTxnStatus
}

export const PaymentStatusBadge = ({ status }: PaymentStatusBadgeProps) => (
  <span
    className={cn(
      'flex h-[26px] shrink-0 items-center justify-center whitespace-nowrap rounded-[12px] font-host text-[14px] font-normal leading-normal',
      STYLES[status],
    )}
  >
    {paymentTxnStatusLabels[status]}
  </span>
)
